import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "@Shared/components/inputs/material-input";
import { validationMixin } from "vuelidate";
import { required, email, minLength } from "vuelidate/lib/validators";
import { asyncValidation } from "@Shared/@Utils/validation-rules";
import { GET_EMAIL_VALIDATION } from "@Broker/@Modules/main/store/account/account-actions";
import { mapActions } from "vuex";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ChoseFlowStep",
  components: {
    MaterialInput
  },
  mixins: [validationMixin],
  validations() {
    return {
      computedClientEmail: {
        required,
        email,
        notBrokerOrAgent: async value => {
          if (email(value) && value !== "") {
            return await asyncValidation({
              email: value,
              type: "consolidated-request"
            }, this.GET_EMAIL_VALIDATION);
          }
        }
      },
      includedRequests: {
        required,
        minLength: minLength(1)
      }
    };
  },
  props: {
    clientRequestEmail: {
      type: String,
      default: null
    },
    currentApplication: {
      type: Object,
      default: () => ({})
    },
    clientEmail: {
      type: String,
      required: true
    },
    includeRequestDocuments: {
      type: Boolean,
      default: false
    },
    includeRequestBankStatements: {
      type: Boolean,
      default: false
    },
    includeSendApplication: {
      type: Boolean,
      default: false
    },
    applicants: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      clientEmailOption: this.clientEmail || "use-another"
    };
  },
  computed: {
    computedClientEmail: {
      get() {
        return this.clientEmail;
      },
      set(value) {
        var _value$toLowerCase;
        this.$emit("select-email-request", (_value$toLowerCase = value == null ? void 0 : value.toLowerCase()) != null ? _value$toLowerCase : value);
      }
    },
    computedIncludeSendApplication: {
      get() {
        return this.includeSendApplication;
      },
      set(value) {
        this.$emit("include-send-application", value);
      }
    },
    computedIncludeRequestDocuments: {
      get() {
        return this.includeRequestDocuments;
      },
      set(value) {
        this.$emit("include-request-documents", value);
      }
    },
    computedincludeRequestBankStatements: {
      get() {
        return this.includeRequestBankStatements;
      },
      set(value) {
        this.$emit("include-request-bank-statements", value);
      }
    },
    includedRequests() {
      var _context;
      return _filterInstanceProperty(_context = [this.includeSendApplication, this.includeRequestDocuments, this.includeRequestBankStatements]).call(_context, request => request);
    },
    isValid() {
      return !this.$v.$invalid;
    },
    applicantsWithoutMainApplicant() {
      var _context2;
      return _filterInstanceProperty(_context2 = this.applicants).call(_context2, ({
        applicantIndex,
        email
      }) => applicantIndex !== 0 && !isEmpty(email));
    },
    mainApplicantName() {
      var _this$applicants$find, _this$applicants$find2, _context3;
      return (_this$applicants$find = (_this$applicants$find2 = _findInstanceProperty(_context3 = this.applicants).call(_context3, ({
        applicantIndex
      }) => applicantIndex === 0)) == null ? void 0 : _this$applicants$find2.applicantFullName) != null ? _this$applicants$find : this.$t("application-form.main-applicant");
    }
  },
  watch: {
    isValid: {
      handler(value) {
        this.$emit("valid", value);
      },
      immediate: true
    }
  },
  mounted() {
    this.$v.$touch();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("AccountStore", [GET_EMAIL_VALIDATION])), {}, {
    handleChangeEmailOption(email) {
      const selectAnotherEmail = email === "use-another";
      const valueToUse = selectAnotherEmail ? "" : email;
      this.handleChangeEmail(valueToUse);
    }
  })
});